import { render, staticRenderFns } from "./ReferenceNumberCard.vue?vue&type=template&id=455c0c15"
import script from "./ReferenceNumberCard.vue?vue&type=script&lang=js"
export * from "./ReferenceNumberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports